import { Modal, PinInput, Stack, Text } from '@mantine/core'
import { Device } from '../../models/Device'

interface RecoveryCodeModalProps {
  opened: boolean
  onClose: () => void
  device: Device
}

function RecoveryCodeModal({
  opened,
  onClose,
  device,
}: RecoveryCodeModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title='Device Recovery Code'
      centered
      size='sm'
      radius='lg'
    >
      <Stack>
        <Text size='sm' c='dimmed'>
          Type this code on your TV to re-link your device
        </Text>
        <PinInput
          oneTimeCode
          autoFocus
          placeholder={'0'}
          size='lg'
          length={6}
          value={device.deviceCode}
          fw={800}
          disabled
        />
      </Stack>
    </Modal>
  )
}

export default RecoveryCodeModal
